export default {
    filters: {
        searchString: null,
        clientIds: []
    },
    patients: [],
    editedPatient: {
        isValid: false,
        validationErrorsByFields: {},
        data: null,
    },
    creationPatient: {
        isValid: false,
        validationErrorsByFields: {},
        data: null,
    },
    totalPatients: 0,
    dataTableOptions: {
        itemsPerPage: 40,
        page: 1
    },
    errorMessagesByFields: {},
}